import { useMemo } from 'react';

import { useLoggedInUserRoles } from '~/components/Auth';
import { useModulesConfig } from '~/data/company';
import { AdminWorkspaceRoles } from '~/data/user/role';

import {
  getAvailableWidgets,
  getWorkspaceRolesbyUserRoles,
} from '../../components/Widgets/data/widgets';

export const useAvailableWidgets = (workspaceRoles?: AdminWorkspaceRoles[]) => {
  const roles = useLoggedInUserRoles();
  const { isModuleEnabled, isModuleTabEnabled } = useModulesConfig();

  return useMemo(() => {
    const wsRoles =
      typeof workspaceRoles !== 'undefined'
        ? workspaceRoles
        : getWorkspaceRolesbyUserRoles(roles);

    return getAvailableWidgets({
      workspaceRoles: wsRoles,
      isModuleEnabled,
      isModuleTabEnabled,
    });
  }, [roles, workspaceRoles, isModuleEnabled, isModuleTabEnabled]);
};
